module.exports = __webpack_public_path__ + "static/media/badge_share_2.54e7f218.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_share_2.png
// module id = 507
// module chunks = 0